import { GetResponseType } from '@/api/types/api';
import { ApiParamsDefinition, ApiResponseDefinition } from '@/api/types/api-definition';
import { IBaseCartGoodsItem } from '@/api/types/cart';
import { IPrice } from '@/api/types/public';
import { IPrescriptionOptions } from '@/components/PrescriptionFormV2/types';

/**
 * 镜片API返回的基础类型
 */
type LensShowBaseItem = GetResponseType<ApiResponseDefinition['GET:/api/lens/lens_show']>[number];

type BaseColorItem = LensShowBaseItem['color_list'][number];

export interface ILensPrice {
  currency?: string;
  price?: string;
  sell_price?: string;
}

export type LensIndexItem = BaseColorItem['lens_list'][number];

// 颜色层添加品牌信息
export type ColorItem = BaseColorItem & {
  brand_name?: string;
  brand_title?: string;
  brand_option_img_m?: string;
  brand_option_img_pc?: string;
  brand_img_m?: string;
  brand_img_pc?: string;
  brand_explain?: string;
  brand_description?: string;
};

export type BrandItem = LensShowBaseItem['brand_list'][number] & {
  default_lens_color?: string;
  lens_type?: string;
};

/**
 * 扩展的镜片类型数据项，添加前端所需的额外字段
 */
export interface LensShowItem extends Omit<LensShowBaseItem, 'brand_list'> {
  sd_lens_type: string;
  merge_lens_type: any;
  /**
   * 默认选中的颜色lens_color
   */
  default_lens_color?: string;
  /**
   * 选中的颜色
   */
  selectedColor?: any;
  /**
   * 移动端类型图片
   */
  type_img_m?: string;
  /**
   * 移动端选项图片
   */
  option_img_m?: string;
  /**
   * PC端选项图片
   */
  option_img_pc?: string;
  /**
   * 品牌列表，扩展了default_lens_color属性
   */
  brand_list?: BrandItem[];
  /**
   * 默认选中的品牌
   */
  default_brand_title?: string;
}

/**
 * 扩展的镜片类型数据数组
 */
export type LensShowResponse = LensShowItem[];

/**
 * 视野区域类型
 */
export enum ELensViewAreaType {
  NORMAL = 'normal',
  ADVANCED = 'advanced',
}

export type CoatingItem = GetResponseType<
  ApiResponseDefinition['GET:/api/lens/coatings_show']
>[number];
export type CoatingList = GetResponseType<ApiResponseDefinition['GET:/api/lens/coatings_show']>;

export type Detail = GetResponseType<ApiResponseDefinition['GET:/api/products/show/{sku}']> & {
  point_price_info?: IPrice[];
};

export type CustomerPrescription = GetResponseType<
  ApiResponseDefinition['GET:/api/customer/prescription']
>['list']['data'][number];

export type IGoodsDetail = GetResponseType<ApiResponseDefinition['GET:/api/products/show/{sku}']>;
type IBaseCartGoodsItemProduct = IBaseCartGoodsItem['product'];
export type LensGoodsItem = IBaseCartGoodsItem & {
  product?: IBaseCartGoodsItemProduct & {
    price_info_pc_v0?: ILensPrice[];
    price_info_wap_v0?: ILensPrice[];
    price_info_pc_v1?: ILensPrice[];
    price_info_wap_v1?: ILensPrice[];
    price_info_pc_v2?: ILensPrice[];
    price_info_wap_v2?: ILensPrice[];
    price_info_pc_v3?: ILensPrice[];
    price_info_wap_v3?: ILensPrice[];
    price_info_pc_v4?: ILensPrice[];
    price_info_wap_v4?: ILensPrice[];
  };
};

/**
 * 镜片处方类型列表
 */
export type BasePresTypeList = GetResponseType<
  ApiResponseDefinition['GET:/api/lens/prescription_type']
>;

export type BaseCartRequestData = ApiParamsDefinition['POST:/api/cart/store']['data'];

export type BasePrescriptionRecognition = GetResponseType<
  ApiResponseDefinition['GET:/api/lens/prescription_recognition']
>;

export type IPrescriptionRecognition = BasePrescriptionRecognition & {
  prescription_type?: string;
};

export interface ILoadPR {
  prescription: IPrescriptionOptions;
  presType?: string;
  record_id: number;
  prescriptions_image: string;
}

export interface IScanInfo {
  recordId: number;
  imageUrl: string;
}
